import React, { useState, useEffect } from 'react';
import { Collapse } from '@mui/material';
import { CollapsibleButton } from '../../../SharedComponents';
import {
  mergeDigInByIndex,
  sortDiginByShap,
  getDigInRankMapping,
} from '../../../../utils/helpers/ticketDetailsHelper';
import { featureImportanceLookup } from './DigInRiskConstants';
import DigInTopFiveRisks from './DigInTopFiveRisks';
import './style.scss';

const DigInRisk = ({ digInRiskModel }) => {
  const [topFiveDigInRisks, setTopFiveDigInRisks] = useState([]);
  const [predictionValue, setPredictionValue] = useState(0);
  const [openDigInDetails, setOpenDigInDetails] = useState(false);
  const digInClassName = 'digin-risk';

  useEffect(() => {
    console.log(digInRiskModel);
    // Handle both 'prediction' (current archive data) and 'predictions' (legacy format)
    if (digInRiskModel?.metadata && digInRiskModel?.prediction) {
      const { metadata, prediction } = digInRiskModel;
      if (metadata?.feature_importance && metadata?.actual_values) {
        const digInData = mergeDigInByIndex(featureImportanceLookup, {
          feature_importance: metadata.feature_importance,
          actual_values: metadata.actual_values,
        });
        const sortedDigIn = sortDiginByShap(digInData);
        const topFiveDigInRisks = sortedDigIn.slice(0, 5);
        setTopFiveDigInRisks(topFiveDigInRisks);
        setPredictionValue(prediction);
      }
    } else if (digInRiskModel?.predictions) {
      // Fallback for legacy format with 'predictions' as JSON string
      const predictionsParsed = JSON.parse(digInRiskModel.predictions);
      const digInRiskData = predictionsParsed.find(
        prediction => prediction?.model_name === 'LM_DigInRisk_Model'
      );
      if (digInRiskData?.dig_in_risk_prediction && digInRiskData?.dig_in_risk_metadata) {
        const { dig_in_risk_prediction, dig_in_risk_metadata } = digInRiskData;
        const digInData = mergeDigInByIndex(featureImportanceLookup, dig_in_risk_metadata);
        const sortedDigIn = sortDiginByShap(digInData);
        const topFiveDigInRisks = sortedDigIn.slice(0, 5);
        setTopFiveDigInRisks(topFiveDigInRisks);
        setPredictionValue(dig_in_risk_prediction);
      }
    }
  }, [digInRiskModel]);

  const { color, text } = getDigInRankMapping(predictionValue);
  const customStylingForDigIn = {
    title: {
      fontSize: '1.5rem',
      alignItems: 'center',
    },
    subText: {
      fontSize: '1.5rem',
      fontWeight: '700',
      marginLeft: 'auto',
      marginRight: '10px',
      color: color,
    },
  };

  return (
    topFiveDigInRisks &&
    topFiveDigInRisks.length > 0 && (
      <div className={digInClassName}>
        <CollapsibleButton
          status={openDigInDetails}
          setStatus={setOpenDigInDetails}
          title="Dig In Risk"
          subText={text}
          customStyling={customStylingForDigIn}
        />
        <Collapse in={openDigInDetails}>
          <hr />
          <DigInTopFiveRisks topFiveDigInRisks={topFiveDigInRisks} />
        </Collapse>
      </div>
    )
  );
};

export default DigInRisk;
